import { assertInstanceOf } from '@blocksuite/global/utils';
import { EditorHost } from '@blocksuite/lit';
export const withHostCommand = (ctx, next) => {
    const host = ctx.std.host;
    assertInstanceOf(host, EditorHost);
    next({ host });
};
//# sourceMappingURL=with-root.js.map